const ITEMS = [
    "NETTOYAGE AUTOMOBILE À DOMICILE",
    "CANNES & ALENTOURS",
    "ON NETTOIE, VOUS BRILLEZ",
    "DETAILING PREMIUM",
    "SERVICE MOBILE CÔTE D'AZUR",
];

const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-sm font-bold uppercase tracking-[0.3em] text-slate-500 sm:text-base">
                    {item}
                </span>
                <span className="text-neon/60">✦</span>
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative overflow-hidden border-y border-neon/10 bg-panel/40 py-5"
    >
        <div className="animate-marquee flex w-max">
            <Row hidden={false} />
            <Row hidden={true} />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-noir to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-noir to-transparent" />
    </div>
);

export default Marquee;
